import React from 'react';
import { DFP_SIZES } from "./ReactDFPHelper";
import { DFPAdvert } from "./DFPAdvert";

export const JobsMpu = () => {
    return (
        <div className="col-12 jobs-Mpu-adv">
                <div className="jobs-mpu">
                    <div className="center-mpu">
                        <DFPAdvert sizes={DFP_SIZES.Block}/>
                    </div>
                </div>
        </div>
    );
};

export default JobsMpu;



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/JobsMpu.js